const getters = {
  isAuthenticated: state => state.auth.isLogin,
  userRoles: state => state.auth.userInfo.roles,
  judul: state => state.pageTitle,
  drawer: state => state.drawer,
  drawerColor: state => state.drawerColor,
  drawerContent: state => state.drawerContent,
  userHome: state => state.auth.userHome,
  token: state => state.auth.token,
  userInfo: state => state.auth.userInfo,
  tahunAnggaran: state => state.tahunAnggaran,

  //rules
  MASA_BERLAKU_SIUP: state => state.rules.find(el => el.key === 'MASA_BERLAKU_SIUP').value,
  PANJANG_MIN_LOGIN: state => state.rules.find(el => el.key === 'PANJANG_MIN_LOGIN').value,
  PANJANG_MIN_PASSWD: state => state.rules.find(el => el.key === 'PANJANG_MIN_PASSWD').value
}

export default getters